var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useRef } from 'react';
import Icon from '../../../icon';
import { NavigationContext } from '../../provider';
import { NavigationItemActiveBar } from '../NavigationItemActiveBar';
import { useScrollButtons } from './hooks';
import { NavigationMainContainer, NavigationMainInner, NavigationMainScrollButton, } from './styles/navigation-main.styled';
export const NavigationMain = (_a) => {
    var { children, onScrollLeftClick, onScrollRightClick, dataTest = 'navigation-main' } = _a, props = __rest(_a, ["children", "onScrollLeftClick", "onScrollRightClick", "dataTest"]);
    const { activeItemReference, setActiveItemReference, navigationIsOpen, navigationViewportBreakpoint, } = useContext(NavigationContext);
    const handleDetectOutsideClick = () => {
        if (activeItemReference) {
            setActiveItemReference(null);
        }
    };
    const navigationMainRef = useRef(null);
    const { hasScroll, scrollButtonLeft, scrollButtonRight, scrollToEdge } = useScrollButtons(navigationMainRef);
    return (_jsxs(_Fragment, { children: [_jsx(NavigationItemActiveBar, {}), _jsx(NavigationMainContainer, { children: _jsxs(NavigationMainInner, Object.assign({ "$navigationIsOpen": navigationIsOpen, "data-test": dataTest }, props, (!['xxs', 'xs', 'sm', 'md'].includes(navigationViewportBreakpoint) && {
                    onMouseLeave: handleDetectOutsideClick,
                }), { ref: navigationMainRef, "data-navigation-main": true, children: [children, hasScroll && (_jsxs(_Fragment, { children: [scrollButtonLeft && (_jsx(NavigationMainScrollButton, { "$position": "left", onClick: (e) => {
                                        scrollToEdge('left');
                                        if (onScrollLeftClick) {
                                            onScrollLeftClick(e);
                                        }
                                    }, "data-test": `${dataTest}-scroll-button-left`, children: _jsx(Icon, { variant: "chevron-left" }) })), scrollButtonRight && (_jsx(NavigationMainScrollButton, { "$position": "right", onClick: (e) => {
                                        scrollToEdge('right');
                                        if (onScrollRightClick) {
                                            onScrollRightClick(e);
                                        }
                                    }, "data-test": `${dataTest}-scroll-button-right`, children: _jsx(Icon, { variant: "chevron-right" }) }))] }))] })) })] }));
};
